<template lang="pug">
  section.home
    Jumbo
    EpicVideo
    TextHistory
    ViewMore
</template>
<script>
import Jumbo from '@/components/Jumbo'
import EpicVideo from '@/components/EpicVideo'
import ViewMore from '@/components/ViewMore'
import TextHistory from '@/components/TextHistory'

export default {
  components: {
    Jumbo,
    EpicVideo,
    ViewMore,
    TextHistory
  }
}
</script>
<style lang="scss" scoped>

</style>

